// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback {
  width: 66rem;
  height: 54.8rem;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
}
.feedback > .left-panel {
  width: 18.5rem;
  display: flex;
}
.feedback > .main-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  min-height: 0;
  min-width: 0;
  align-items: center;
}
.feedback > .main-panel > .close {
  height: 4rem;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
}
.feedback > .main-panel > .close > i.icon-cancel {
  position: relative;
  width: 2.4rem;
  height: 2.1455rem;
  font-size: 2.4rem;
  cursor: pointer;
  color: #7f7f7f;
  margin-right: 1.2rem;
}
.feedback > .main-panel > .header {
  flex: none;
  display: flex;
  width: 47.5rem;
  padding: 0rem 2.5rem 0rem 2.5rem;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}
.feedback > .main-panel > .header > .title {
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  /* 2.88rem */
}
.feedback > .main-panel > .header > .raiting-panel {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
}
.feedback > .main-panel > .header > .raiting-panel.invalid svg {
  stroke-width: 1px;
  stroke: red;
}
.feedback > .main-panel > .header > .raiting-panel > .star {
  width: 4.4rem;
  height: 4.4rem;
}
.feedback > .main-panel > .header > .raiting-panel > .star.state-selected svg path {
  stroke-width: 1px;
  fill: #5541d7;
}
.feedback > .main-panel > .header > .raiting-panel > .star.state-hover svg path {
  stroke-width: 1px;
  fill: #766eda;
}
.feedback > .main-panel > .header > .raiting-panel > .star:not(.state-selected):hover {
  cursor: pointer;
}
.feedback > .main-panel > .header > .raiting-panel > .star:not(.state-selected):hover > svg path {
  stroke-width: 1px;
  fill: #766eda;
}
.feedback > .main-panel > .header > .raiting-panel > .star:hover {
  cursor: pointer;
}
.feedback > .main-panel > .header > .raiting-panel > .star:hover > .state-selected svg path {
  stroke-width: 1px;
  fill: #5541d7;
}
.feedback > .main-panel > .content {
  display: flex;
  width: 47.5rem;
  padding-top: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3.5rem;
}
.feedback > .main-panel > .content > * {
  width: 39.3rem;
}
.feedback > .main-panel > .content > .text {
  flex: 1 0 0;
  color: var(--grey-icon);
  text-align: center;
  font-family: Roboto;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  /* 1.96rem */
}
.feedback > .main-panel > .content > .main-data {
  width: 39.7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}
.feedback > .main-panel > .content > .main-data > .feedback-types {
  width: 100%;
  height: 1.8rem;
  padding: 0rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
.feedback > .main-panel > .content > .main-data > .feedback-types > .radios {
  display: flex;
  gap: 4rem;
}
.feedback > .main-panel > .content > .main-data > .feedback-types > .radios > app-radio ::ng-deep label {
  color: var(--grey-icon);
  font-family: Roboto;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
.feedback > .main-panel > .content textarea {
  border-radius: 0.8rem;
  border: 1px solid var(--primary-color-10, #dbd7f4);
  background: var(--system-background-primary, #fff);
  padding: 2rem;
  height: 15rem;
}
.feedback > .main-panel > .content textarea::placeholder {
  color: var(--text-color-body-1, #92929d);
  /* Base/Body/Text 14 Regular */
  font-family: Roboto;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
.feedback > .main-panel > .content > .actions-panel {
  height: 1.2rem;
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 2rem;
}
.feedback > .main-panel > .actions-panel {
  width: 39.3rem;
  flex: none;
  height: 11.2rem;
  align-items: center;
  justify-content: flex-start;
  display: flex;
  flex-direction: row;
  gap: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/feedback/components/feedback/feedback.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AACF;AACE;EACE,cAAA;EACA,aAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAEI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;AAAN;AAEM;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAAR;AAII;EACE,UAAA;EACA,aAAA;EACA,cAAA;EACA,gCAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAFN;AAIM;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAFR;AAKM;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAHR;AAKQ;EACE,iBAAA;EACA,WAAA;AAHV;AAMQ;EACE,aAAA;EACA,cAAA;AAJV;AAMU;EACE,iBAAA;EACA,aAAA;AAJZ;AAOU;EACE,iBAAA;EACA,aAAA;AALZ;AAQU;EACE,eAAA;AANZ;AAQY;EACE,iBAAA;EACA,aAAA;AANd;AAUU;EACE,eAAA;AARZ;AAUY;EACE,iBAAA;EACA,aAAA;AARd;AAeI;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAbN;AAeM;EACE,cAAA;AAbR;AAgBM;EACE,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAdR;AAiBM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAfR;AAiBQ;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;AAfV;AAiBU;EACE,aAAA;EACA,SAAA;AAfZ;AAiBY;EACE,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAfd;AAqBM;EACE,qBAAA;EACA,kDAAA;EACA,kDAAA;EACA,aAAA;EACA,aAAA;AAnBR;AAqBQ;EACE,wCAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAnBV;AAuBM;EACE,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AArBR;AAyBI;EACE,cAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAvBN","sourcesContent":[".feedback {\n  width: 66rem;\n  height: 54.8rem;\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n\n  & > .left-panel {\n    width: 18.5rem;\n    display: flex;\n  }\n\n  & > .main-panel {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 100%;\n    min-height: 0;\n    min-width: 0;\n    align-items: center;\n\n    & > .close {\n      height: 4rem;\n      display: flex;\n      align-items: center;\n      width: 100%;\n      justify-content: flex-end;\n\n      & > i.icon-cancel {\n        position: relative;\n        width: 2.4rem;\n        height: 2.1455rem;\n        font-size: 2.4rem;\n        cursor: pointer;\n        color: #7f7f7f;\n        margin-right: 1.2rem;\n      }\n    }\n\n    & > .header {\n      flex: none;\n      display: flex;\n      width: 47.5rem;\n      padding: 0rem 2.5rem 0rem 2.5rem;\n      flex-direction: column;\n      align-items: center;\n      gap: 2rem;\n\n      & > .title {\n        color: #000;\n        text-align: center;\n        font-family: Roboto;\n        font-size: 2.4rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 120%;\n        /* 2.88rem */\n      }\n\n      & > .raiting-panel {\n        display: flex;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 1rem;\n\n        &.invalid svg {\n          stroke-width: 1px;\n          stroke: red;\n        }\n\n        & > .star {\n          width: 4.4rem;\n          height: 4.4rem;\n\n          &.state-selected svg path {\n            stroke-width: 1px;\n            fill: #5541d7;\n          }\n\n          &.state-hover svg path {\n            stroke-width: 1px;\n            fill: #766eda;\n          }\n\n          &:not(.state-selected):hover {\n            cursor: pointer;\n\n            & > svg path {\n              stroke-width: 1px;\n              fill: #766eda;\n            }\n          }\n\n          &:hover {\n            cursor: pointer;\n\n            & > .state-selected svg path {\n              stroke-width: 1px;\n              fill: #5541d7;\n            }\n          }\n        }\n      }\n    }\n\n    & > .content {\n      display: flex;\n      width: 47.5rem;\n      padding-top: 40px;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 3.5rem;\n\n      & > * {\n        width: 39.3rem;\n      }\n\n      & > .text {\n        flex: 1 0 0;\n        color: var(--grey-icon);\n        text-align: center;\n        font-family: Roboto;\n        font-size: 1.4rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 140%;\n        /* 1.96rem */\n      }\n\n      & > .main-data {\n        width: 39.7rem;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 2rem;\n\n        & > .feedback-types {\n          width: 100%;\n          height: 1.8rem;\n          padding: 0rem 2rem;\n          display: flex;\n          flex-direction: column;\n          justify-content: space-between;\n          align-items: flex-start;\n\n          & > .radios {\n            display: flex;\n            gap: 4rem;\n\n            & > app-radio ::ng-deep label {\n              color: var(--grey-icon);\n              font-family: Roboto;\n              font-size: 1.4rem;\n              font-style: normal;\n              font-weight: 400;\n              line-height: 120%;\n            }\n          }\n        }\n      }\n\n      textarea {\n        border-radius: 0.8rem;\n        border: 1px solid var(--primary-color-10, #dbd7f4);\n        background: var(--system-background-primary, #fff);\n        padding: 2rem;\n        height: 15rem;\n\n        &::placeholder {\n          color: var(--text-color-body-1, #92929d);\n          /* Base/Body/Text 14 Regular */\n          font-family: Roboto;\n          font-size: 1.4rem;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 120%;\n        }\n      }\n\n      & > .actions-panel {\n        height: 1.2rem;\n        align-items: center;\n        display: flex;\n        flex-direction: row;\n        gap: 2rem;\n      }\n    }\n\n    & > .actions-panel {\n      width: 39.3rem;\n      flex: none;\n      height: 11.2rem;\n      align-items: center;\n      justify-content: flex-start;\n      display: flex;\n      flex-direction: row;\n      gap: 2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
